import searchDeclaration from './view/searchDeclaration.html'

export default {
    base: {
        state: 'declaration.addValTaxDeclaration.searchDeclaration',
        config: {
            url: '/searchDeclaration',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.addValTaxDeclaration.searchDeclaration.list',
            title: '申报表查询',
        },
    },
    list: {
        state: 'declaration.addValTaxDeclaration.searchDeclaration.list',
        config: {
            url: '/list',
            template: searchDeclaration,
            controller: 'searchDeclarationCtrl',

        },
    },
    detail: {
        state: 'declaration.addValTaxDeclaration.searchDeclaration.detail',
        config: {
            url: '/detail/:obj',
            template: require('./view/searchDeclarationDetail.html'),
            controller: 'searchDeclarationDetailCtrl',
            title: '申报表详情',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/searchDeclaration/routers.js